/**
 * 국가 코드 데이터
 * - 국기 이모지, 국가 코드, 국가 전화번호 코드 포함
 */

export interface CountryCodeInfo {
  /** 국가 코드 (ISO 3166-1 alpha-2) */
  code: string;
  /** 국가명 (한국어) */
  name: string;
  /** 국기 이모지 */
  flag: string;
  /** 국가 전화번호 코드 */
  dialCode: string;
}

/**
 * 지원하는 국가 목록
 * 주요 국가들을 우선 배치
 */
export const COUNTRY_CODE_LIST: CountryCodeInfo[] = [
  { code: 'KR', name: '대한민국', flag: '🇰🇷', dialCode: '+82' },
  // { code: 'US', name: '미국', flag: '🇺🇸', dialCode: '+1' },
  // { code: 'JP', name: '일본', flag: '🇯🇵', dialCode: '+81' },
  // { code: 'CN', name: '중국', flag: '🇨🇳', dialCode: '+86' },
  // { code: 'TW', name: '대만', flag: '🇹🇼', dialCode: '+886' },
  // { code: 'HK', name: '홍콩', flag: '🇭🇰', dialCode: '+852' },
  // { code: 'SG', name: '싱가포르', flag: '🇸🇬', dialCode: '+65' },
  // { code: 'TH', name: '태국', flag: '🇹🇭', dialCode: '+66' },
  // { code: 'VN', name: '베트남', flag: '🇻🇳', dialCode: '+84' },
  // { code: 'PH', name: '필리핀', flag: '🇵🇭', dialCode: '+63' },
  // { code: 'MY', name: '말레이시아', flag: '🇲🇾', dialCode: '+60' },
  // { code: 'ID', name: '인도네시아', flag: '🇮🇩', dialCode: '+62' },
  // { code: 'IN', name: '인도', flag: '🇮🇳', dialCode: '+91' },
  // { code: 'AU', name: '호주', flag: '🇦🇺', dialCode: '+61' },
  // { code: 'NZ', name: '뉴질랜드', flag: '🇳🇿', dialCode: '+64' },
  // { code: 'GB', name: '영국', flag: '🇬🇧', dialCode: '+44' },
  // { code: 'DE', name: '독일', flag: '🇩🇪', dialCode: '+49' },
  // { code: 'FR', name: '프랑스', flag: '🇫🇷', dialCode: '+33' },
  // { code: 'IT', name: '이탈리아', flag: '🇮🇹', dialCode: '+39' },
  // { code: 'ES', name: '스페인', flag: '🇪🇸', dialCode: '+34' },
  // { code: 'NL', name: '네덜란드', flag: '🇳🇱', dialCode: '+31' },
  // { code: 'CA', name: '캐나다', flag: '🇨🇦', dialCode: '+1' },
  // { code: 'BR', name: '브라질', flag: '🇧🇷', dialCode: '+55' },
  // { code: 'MX', name: '멕시코', flag: '🇲🇽', dialCode: '+52' },
  // { code: 'RU', name: '러시아', flag: '🇷🇺', dialCode: '+7' },
];

/** 기본 국가 코드 */
export const DEFAULT_COUNTRY_CODE = 'KR';

/**
 * 국가 코드로 국가 정보 조회
 */
export const getCountryByCode = (code: string): CountryCodeInfo | undefined => {
  return COUNTRY_CODE_LIST.find(country => country.code === code);
};

/**
 * 전화번호를 E.164 형식으로 변환
 * @param phoneNumber 사용자 입력 (예: "010-1234-5678", "01012345678")
 * @param countryCode ISO 3166-1 alpha-2 국가 코드 (예: "KR", "US")
 * @returns E.164 형식 (예: "+821012345678")
 */
export const toE164Format = (
  phoneNumber: string,
  countryCode: string = 'KR',
): string => {
  // 숫자만 추출
  const digits = phoneNumber.replace(/\D/g, '');

  // 이미 E.164 형식인 경우
  if (phoneNumber.startsWith('+')) {
    return '+' + digits;
  }

  // 국가 정보 조회
  const country = getCountryByCode(countryCode);
  if (!country) {
    return `+${digits}`;
  }

  // dialCode에서 + 제거
  const dialingCode = country.dialCode.replace('+', '');

  // 0으로 시작하면 0 제거 (예: 010 → 10)
  const nationalNumber = digits.startsWith('0') ? digits.substring(1) : digits;

  return `+${dialingCode}${nationalNumber}`;
};
